import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
type Faq = {
  question: string;
  answer: string[];
  bullets?: string[];
  closing?: string;
};
const faqs: Faq[] = [{
  question: 'How do I receive Barre Instructor Ready after purchasing?',
  answer: ['You receive digital access after your purchase is completed.', 'The complete package is delivered as PDF resources that can be accessed from compatible devices.']
}, {
  question: 'Is this an app?',
  answer: ['No.', 'Barre Instructor Ready is a digital PDF teaching system.', 'The materials can be opened on compatible phones, tablets and computers.']
}, {
  question: 'Does the package contain videos?',
  answer: ['No.', 'The core teaching material was intentionally designed as a 100% visual PDF system, using movement sequences, body-position visuals, directional arrows, progressions, corrections and class structures.']
}, {
  question: 'Is the material in English?',
  answer: ['Yes.', 'Barre Instructor Ready is created in English.']
}, {
  question: 'Can I edit the files?',
  answer: ['No.', 'The resources are delivered as finished PDF material.']
}, {
  question: 'Is this only for beginner instructors?',
  answer: ['No.', 'The system can be useful for both newer and experienced Barre instructors who want ready-made class structures, more variety and faster planning.']
}, {
  question: 'Is this only for beginner students?',
  answer: ['No.', 'The complete 6-in-1 system includes beginner classes, intermediate development and progressive Barre programming.']
}, {
  question: 'Do I need special equipment?',
  answer: ['Not for every class.', 'Classes use different combinations of:'],
  bullets: ['Barre', 'stable chair when appropriate', 'mat', 'mini resistance band', 'small Barre ball'],
  closing: 'Many classes require only the Barre or stable support.'
}, {
  question: 'Are the 150 classes all lower-body classes?',
  answer: ['No.', 'The complete system contains 150 classes across six different Barre-focused volumes covering beginner instruction, lower body, core and balance, upper body and posture, cardio/full-body Barre and progressive class programming.']
}, {
  question: 'Can I use only the classes that fit my teaching style?',
  answer: ['Yes.', 'The system is designed as a library.', 'Choose the class, body focus, level and format that fits your students and your schedule.']
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="border-t border-primary/10 bg-background px-4 py-20 sm:py-28" data-id="element-98" data-mp="1n9ptp643xuri">
      <div className="mx-auto max-w-3xl" data-id="element-99" data-mp="1j5rxb3662y25">
        <div className="text-center" data-id="element-100" data-mp="3utwpgezzy79k">
          <p className="text-sm font-semibold uppercase tracking-[0.18em] text-primary" data-id="element-101" data-mp="3uuy1alou6xsc">
            FAQ
          </p>
          <h2 className="mt-3 text-3xl font-semibold text-foreground sm:text-4xl" data-id="element-102" data-mp="2qnfq4wuab0l">
            Frequently Asked <span className="italic text-primary" data-id="element-103" data-mp="7nnmyj5fdjta">Questions</span>
          </h2>
        </div>
        <div className="mt-12 space-y-3" data-id="element-104" data-mp="cgp3swp6ztfi">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.question} className="overflow-hidden rounded-lg border border-primary/20 bg-surface" data-id="element-105" data-mp="mduuw4xt3kfq" data-mpi={index}>
                <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-6 px-6 py-5 text-left transition-colors duration-150 hover:bg-surface-subtle focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-primary" data-id="element-106" data-mp="qghq8ftornho">
                  <span className="text-base font-semibold text-foreground" data-id="element-107" data-mp="1wwwo27uuezu0">
                    {faq.question}
                  </span>
                  <ChevronDownIcon size={20} aria-hidden="true" className={`shrink-0 text-primary transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} data-id="element-108" data-mp="2bt47v72c9z8r" />
                </button>
                <AnimatePresence initial={false} data-id="element-109" data-mp="1e6ncw8h2vxq6">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-110" data-mp="1e4kdwyxy6u9b">
                      <div className="space-y-2 border-t border-primary/15 px-6 py-5 text-sm leading-6 text-muted-foreground" data-id="element-111" data-mp="vfxcqriw6p10">
                        {faq.answer.map(paragraph => <p key={paragraph} data-id="element-112" data-mp="371fwk1i0bep5">{paragraph}</p>)}
                        {faq.bullets && <ul className="list-disc space-y-1 pl-5 marker:text-primary" data-id="element-113" data-mp="2x5l8gqv0krez">
                            {faq.bullets.map(bullet => <li key={bullet} data-id="element-114" data-mp="324fu00kd8u2s">{bullet}</li>)}
                          </ul>}
                        {faq.closing && <p data-id="element-115" data-mp="3urse84320psx">{faq.closing}</p>}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}